import React from 'react';
import { faTrash } from '@fortawesome/free-solid-svg-icons';

import { AppTable, AppTableColumn } from '../../table/appTable';
import Button from '../../buttons/button';
import { createLink } from '../utils/link-builder';

import { MusicActionButtonsProps, MusicTableProps } from './music.types';

const ActionButtons = ({ original, onDelete }: MusicActionButtonsProps) => {
  return (
    <>
      <Button
        text="Delete Music"
        icon={faTrash}
        slimButton
        onClick={e => {
          e.stopPropagation();
          onDelete(original.id);
        }}
      />
    </>
  );
};

export const MusicTable = ({ music, isLoading, onClickDelete }: MusicTableProps) => {
  const columns: AppTableColumn[] = [
    {
      Header: 'Name',
      id: 'name',
      accessor: 'name',
      width: 400,
    },
    {
      Header: 'Description',
      id: 'description',
      accessor: 'description',
      width: 400,
    },
    {
      Header: 'Music File',
      id: 'musicFileUrl',
      accessor: 'fileUrl',
      width: 300,
      Cell: ({ row }) => createLink(row, 'musicFileUrl', 'Preview Audio'),
    },
    {
      Header: 'Institution',
      id: 'institutionName',
      accessor: 'institutionName',
      width: 300,
    },
    {
      Header: 'Actions',
      id: 'actions',
      accessor: 'actions',
      width: 300,
      Cell: ({ original }) => <ActionButtons original={original} onDelete={onClickDelete} />,
    },
  ];

  return (
    <AppTable
      columns={columns}
      tableName="music-management"
      loading={isLoading}
      data={music}
      defaultSorted={[{ id: 'name', desc: false }]}
    />
  );
};
